export const NOVY_ZAZNAM = 'NOVY_ZAZNAM';
export const PODANO = 'PODANO';
export const ROZPRACOVANO = 'ROZPRACOVANO';
export const ZAMITNUTO = 'ZAMITNUTO';
export const SCHVALENO = 'SCHVALENO';
export const UHRAZENO = 'UHRAZENO';
export const ZRUSENO = 'ZRUSENO';

const icons = {
    [NOVY_ZAZNAM]: 'circle',
    [PODANO]: 'play-circle-o',
    [ROZPRACOVANO]: 'clock-o',
    [ZAMITNUTO]: 'ban',
    [SCHVALENO]: 'check-square-o',
    [UHRAZENO]: 'money',
    [ZRUSENO]: 'times-circle-o',
};

const captions = {
    [NOVY_ZAZNAM]: 'Nový záznam',
    [PODANO]: 'Podáno',
    [ROZPRACOVANO]: 'Rozpracováno',
    [ZAMITNUTO]: 'Zamítnuto',
    [SCHVALENO]: 'Schváleno',
    [UHRAZENO]: 'Uhrazeno',
    [ZRUSENO]: 'Zrušeno',
};

const colors = {
    [NOVY_ZAZNAM]: '#808080',
    [PODANO]: '#b46008',
    [ROZPRACOVANO]: '#9d0c12',
    [ZAMITNUTO]: '#9d0c12',
    [SCHVALENO]: '#39761d',
    [UHRAZENO]: '#39761d',
    [ZRUSENO]: '#9d0c12',
};

export const values = [
    NOVY_ZAZNAM,
    PODANO,
    ROZPRACOVANO,
    ZAMITNUTO,
    SCHVALENO,
    UHRAZENO,
    ZRUSENO,
];

export function getIcon(value) {
    return icons[value];
}

export function getCaption(value) {
    return captions[value];
}
